import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        imagePosition: "top center",
        name: "Bobby Glaspie Jr",
        title: "Owner",
        biography: "Bobby Glaspie Jr brings over a decade of passion and expertise to the coffee industry. As the CEO of BrewCraft Café, he has transformed the shop into a favorite destination for coffee lovers. His commitment to ethically sourced beans, innovative brews, and exceptional customer service has redefined the local coffee scene. Outside of operations, Bobby mentors aspiring baristas and leads sustainability initiatives.",
        contacts: {
            phone: "(678) 927-8428",
            email: "bobby.glaspie@brewcraftcafe.com",
            address: "2667 Powder Springs Rd SW, Ste 105, Marietta, GA 30064",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Coffee Curation", progress: 97 },
            { id: 2, title: "Barista Training", progress: 94 },
            { id: 3, title: "Customer Engagement", progress: 92 },
            { id: 4, title: "Business Strategy", progress: 90 },
            { id: 5, title: "Sustainable Sourcing", progress: 89 },
            { id: 6, title: "Menu Innovation", progress: 93 },
        ]
    },
    {
        id: 2,
        image: images.team2,
        imagePosition: "top center",
        name: "Kephern Murphy",
        title: "Owner",
        biography: "Kephern Murphy founded BrewCraft Café with a simple vision — to bring people together over a perfect cup of coffee. With a background in culinary arts and a deep appreciation for global coffee cultures, Kephern laid the foundation for a café that values authenticity, quality, and community. Her hands-on approach and eye for design have shaped every detail, from bean selection to cozy interiors.",
        contacts: {
            phone: "(678) 927-8428",
            email: "kephern.murphy@brewcraftcafe.com",
            address: "2667 Powder Springs Rd SW, Ste 105, Marietta, GA 30064",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Brand Building", progress: 96 },
            { id: 2, title: "Coffee Culture", progress: 94 },
            { id: 3, title: "Interior Aesthetics", progress: 91 },
            { id: 4, title: "Leadership", progress: 93 },
            { id: 5, title: "Product Vision", progress: 92 },
            { id: 6, title: "Community Outreach", progress: 90 },
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "",
        title: "Manager",
        biography: "Paul Roger oversees daily operations at BrewCraft Café, ensuring everything runs smoothly — from staff coordination to customer service excellence. With years of experience in hospitality management, Paul brings a balance of professionalism and warmth, making sure every guest feels welcome and every cup meets the café’s high standards.",
        contacts: {
            phone: "(678) 927-8428",
            email: "paul.roger@brewcraftcafe.com",
            address: "2667 Powder Springs Rd SW, Ste 105, Marietta, GA 30064",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Team Management", progress: 95 },
            { id: 2, title: "Customer Relations", progress: 93 },
            { id: 3, title: "Inventory Control", progress: 90 },
            { id: 4, title: "Operational Efficiency", progress: 92 },
            { id: 5, title: "Staff Training", progress: 89 },
            { id: 6, title: "Problem Solving", progress: 94 },
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Kameron Murphy",
        title: "Marketing Director",
        biography: "Kameron Murphy brings energy and precision to BrewCraft Café’s operations. With a background in hospitality and a deep passion for coffee culture, he ensures that the café delivers exceptional service and a welcoming environment. Kameron excels in team coordination, customer satisfaction, and maintaining the high standards that define BrewCraft Café.",
        contacts: {
            phone: "(678) 927-8428",
            email: "kameron.murphy@brewcraftcafe.com",
            address: "2667 Powder Springs Rd SW, Ste 105, Marietta, GA 30064",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Operational Management", progress: 94 },
            { id: 2, title: "Customer Engagement", progress: 96 },
            { id: 3, title: "Staff Coordination", progress: 92 },
            { id: 4, title: "Time Management", progress: 90 },
            { id: 5, title: "Service Quality Control", progress: 93 },
            { id: 6, title: "Café Ambiance Planning", progress: 91 },
        ]
    }

];

export default team;
